import { Notifier, Option } from "@opendaw/lib-std";
export class UserEditing {
    #editing;
    #notifier;
    #subscription = Option.None;
    #pointer = Option.None;
    constructor(editing) {
        this.#editing = editing;
        this.#notifier = new Notifier();
    }
    catchupAndSubscribe(observer) {
        observer(this.get());
        return this.#notifier.subscribe(observer);
    }
    follow(pointer) {
        this.#pointer = Option.wrap(pointer);
        this.#subscription.ifSome(subscription => subscription.terminate());
        this.#subscription = Option.wrap(pointer
            .catchupAndSubscribe(pointer => this.#notifier.notify(pointer.targetVertex)));
    }
    edit(target) {
        this.#pointer.ifSome(pointer => this.#editing.modify(() => pointer.refer(target)));
    }
    isEditing(vertex) {
        return this.#pointer.match({
            none: () => false,
            some: pointer => pointer.targetVertex.contains(vertex)
        });
    }
    get() { return this.#pointer.flatMap(pointer => pointer.targetVertex); }
    clear() { this.#pointer.ifSome(pointer => this.#editing.modify(() => pointer.defer())); }
    terminate() {
        this.#pointer = Option.None;
        this.#subscription.ifSome(subscription => subscription.terminate());
        this.#subscription = Option.None;
        this.#notifier.notify(Option.None);
        this.#notifier.terminate();
    }
}
